<div *ngIf="msg">
  <div [ngClass]="['msgContainer', msg.class]">
    <div class="msgImg">
      <img alt="" src="{{ msg.img }}" />
    </div>
    <div class="msgText">
      <div class="msgheading">{{ msg.heading }}</div>
      <div class="msgsummary" [innerHTML]="msg.text"></div>
    </div>
    <div class="msgClose" (click)="close_msg()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <use href="../../../../assets/icons/tenantCustomIcons/close-icon.svg#homeIcon" />
      </svg>
    </div>
  </div>
</div>
